import { JetfabricError } from '../errors';
import { constants } from '../constants';

// tslint:disable-next-line:no-any
export const withTimeout = <T>(
  originalPromise: Promise<T>,
  timeout: number = constants.DEFAULT_TIMEOUT as number
): Promise<T> =>
  Promise.race([
    originalPromise,
    new Promise((_resolve, reject) => {
      setTimeout(() => {
        reject(new JetfabricError(`timeout (waited ${timeout} ms)`));
      }, timeout);
    }),
  ]) as Promise<T>;

export const timestampFactory = (): Date => new Date();

export const perfTimestampFactory = (): number => performance.now();

export const getTimezone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    return timestampFactory().getTimezoneOffset() + '';
  }
};
